export const USER_CODES = {
  U002: 'phoneAlreadyTaken',
};
